import { getInitialValue } from 'hb-react/shared/components/formik/utils/customAttributes';

import * as FilterTypes from '../constants/FilterTypes';
import parseStringJSON from '../utils/parseStringJSON';

const RANGE_FILTERS = [
  FilterTypes.DATE_RANGE,
  FilterTypes.NUMBER_RANGE,
  FilterTypes.DECIMAL_RANGE,
  FilterTypes.YEAR_RANGE,
];
const CLASSIC_CUSTOM_ATTRIBUTES_FILTER_TYPES = [
  FilterTypes.BOOLEAN,
  FilterTypes.SELECT,
  FilterTypes.FULLTEXT_SELECT,
  FilterTypes.DOUBLE_SELECT,
];
const ARRAY_FILTERS = [
  FilterTypes.INDUSTRIES,
  FilterTypes.SKILLS,
  FilterTypes.NATIONALITIES,
  FilterTypes.SUB_NETWORKS,
  FilterTypes.COMPANIES,
  FilterTypes.SCHOOLS,
  FilterTypes.DEGREES,
  FilterTypes.FIELD_OF_STUDIES,
];

export const getInitialValues = ({
  initialFiltersFromConfig = {},
  searchParamsFilters = {},
  filters,
}) => {
  if (!filters) {
    return {
      query: {
        ...initialFiltersFromConfig,
      },
    };
  }

  const topFilters = reduceOnAllTypesOfValue(filters.top, searchParamsFilters);
  const overlayFilters = getOverlayValues(filters.overlay, searchParamsFilters); // this should no longer work since overlay filters are fetched once the modal is opened
  const searchParamFilters = getSearchParamsFilters(searchParamsFilters);

  return {
    query: {
      // For fixed filters that should not be updated
      ...initialFiltersFromConfig,
      ...searchParamFilters,
      ...topFilters,
      ...overlayFilters,
    },
  };
};

const getOverlayValues = (overlayBlocks, searchParamsFilters) => {
  let overlayFilters = {};

  overlayBlocks.forEach((block) => {
    overlayFilters = {
      ...overlayFilters,
      ...reduceOnAllTypesOfValue(block.filters, searchParamsFilters),
    };
  });

  return overlayFilters;
};

const reduceOnAllTypesOfValue = (filters, searchParamsFilters) => {
  const blockFilters = {};

  filters.forEach((filter) => {
    let initialValue = searchParamsFilters[filter.name];

    if (filter.type === FilterTypes.CHECKBOX) {
      blockFilters[filter.name] = initialValue === 'true';
    }
    if (RANGE_FILTERS.includes(filter.type)) {
      blockFilters[`min_${filter.name}`] =
        searchParamsFilters[`min_${filter.name}`] || '';
      blockFilters[`max_${filter.name}`] =
        searchParamsFilters[`max_${filter.name}`] || '';
    }
    if (CLASSIC_CUSTOM_ATTRIBUTES_FILTER_TYPES.includes(filter.type)) {
      initialValue =
        filter.type === 'boolean'
          ? initialValue?.toString()
          : parseStringJSON(initialValue);
      blockFilters[filter.name] = getInitialValue(
        initialValue || filter.value,
        filter.type,
      );
    }
    if (
      filter.type === FilterTypes.FREE_TEXT ||
      filter.type === FilterTypes.SELECT_WITH_SEARCH_AND_OTHER_OPTIONS
    ) {
      blockFilters[filter.name] = initialValue || '';
    }
    if (
      filter.type === FilterTypes.EDUCATIONS_YEAR_FROM ||
      filter.type === FilterTypes.EDUCATIONS_YEAR_TO
    ) {
      blockFilters[filter.name] = initialValue || '';
    }
    if (ARRAY_FILTERS.includes(filter.type)) {
      blockFilters[filter.name] = parseStringJSON(initialValue) || [];
    }
    if (filter.type === FilterTypes.LOCATION) {
      // Not scalable, we need to handle the location under a real key and use the name of this key, not put it hardcoded at the root of values
      blockFilters.lat = searchParamsFilters.lat || '';
      blockFilters.lng = searchParamsFilters.lng || '';
      blockFilters.address = searchParamsFilters.address || '';
      blockFilters.colloquial_area = searchParamsFilters.colloquial_area || '';
      blockFilters.neighborhood = searchParamsFilters.neighborhood || '';
      blockFilters.city = searchParamsFilters.city || '';
      blockFilters.administrative_area_level_1 =
        searchParamsFilters.administrative_area_level_1 || '';
      blockFilters.administrative_area_level_2 =
        searchParamsFilters.administrative_area_level_2 || '';
      blockFilters.country = searchParamsFilters.country || '';
      blockFilters.location_level = searchParamsFilters.location_level || '';
      blockFilters.country_code = searchParamsFilters.country_code || '';
      blockFilters.postal_code = searchParamsFilters.postal_code || '';
      blockFilters.provider = searchParamsFilters.provider || '';
    }
  });

  return blockFilters;
};

export const getSearchParamsFilters = (searchParamFilters = {}) => {
  const searchParams = {};

  Object.entries(searchParamFilters).forEach(([key, value]) => {
    searchParams[key] = parseStringJSON(value);
  });

  return searchParams;
};
